export interface ForemanEquipmentImport {
  equipmentDispatchID: string | null;
  jobID: string | null;
  equipment: string | null;
  shift: number | null;
  equipmentName: string | null;
  altID: string | null;
  workOrder: string | null;
  workOrderID: string | null;
  isBillableWorkOrder: boolean;
  customerPO: string | null;
  workOrderDescription: string | null;
  billingTemplate: string | null;
  dispatches: ForemanEquipmentDispatchDetailImport[];
  details: ForemanEquipmentUsageImport[];
  foremanSummary: ForemanEquipmentEntrySummary | null;
  foremanTimeImportID: string;
  foremanEquipmentDispatchID?: string | null;
}

export interface ForemanEquipmentDispatchImport {
  jobID: string;
  equipmentName: string | null;
  displayName: string | null;
  startDate: Date | null;
  endDate: Date | null;
  altID: string | null;
  customerID: string | null;
  vpCompanyID: number;
  bActive: boolean;
  details: ForemanEquipmentDispatchDetailImport[];
}

export interface ForemanEquipmentDispatchDetailImport {
  equipmentDispatchID: string | null;
  equipmentID: string | null;
  billingRate: number | null;
  equipmentBillingID: string | null;
  unitName: string | null;
}

export interface ForemanEquipmentUsageImport {
  equipmentUsageID: string | null;
  dateUsed: Date | null;
  amount: number | null;
  bActive: boolean | null;
  foremanEquipmentUsageID: string | null;
  isMapped?: boolean;
  notes?: string | null;
}

export interface ForemanEquipmentEntrySummary {
  foremanCrew: string | null;
  workOrder: string | null;
  shift: string | null;
  quantity: number | null;
  hours: number | null;
  foremanEquipmentUsageID: string | null;
  notes?: string | null;
}
